import React from 'react';
import { SvgContainer } from '../components/styled';

export type TooltipIconProps = {
  readonly fillColor?: string;
};

export function TooltipIcon({ fillColor }: TooltipIconProps) {
  return (
    <SvgContainer>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
        <path
          d="M9 18c5 0 9-4 9-9s-4-9-9-9-9 4-9 9 4 9 9 9zM5 7c0-2.5 2.3-4.5 4.9-3.9 1.4.3 2.6 1.5 3 2.9.5 2.1-.7 4-2.5 4.7-.2.1-.4.3-.4.5v.8c0 .6-.4 1-1 1s-1-.4-1-1v-2c0-.5.4-1 1-1 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .5-.5 1-1 1s-1-.4-1-1zm4 9c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
          fillRule="evenodd"
          clipRule="evenodd"
          fill={fillColor}
        />
      </svg>
    </SvgContainer>
  );
}
